// @flow
import { values } from 'utils/functional/object';
import type { Notification } from 'api/currentUser';

export const sortNotifications = (
  unsortedNotifications: Array<Notification>
) => {
  const [
    applicantNotifications: Array<Notification>,
    otherNotifications: Array<Notification>
  ] = unsortedNotifications.reduce(
    (acc, notification) => {
      acc[notification.type === 'NEW_LISTING_APPLICATION' ? 0 : 1].push(
        notification
      );
      return acc;
    },
    [[], []]
  );

  const notificationsByListingId = applicantNotifications.reduce(
    (acc, notification) => {
      if (notification.type === 'NEW_LISTING_APPLICATION') {
        const notificationListing =
          notification.data.listingApplication.listing;
        const listing = acc[notificationListing.id] || {
          type: 'NEW_APPLICATIONS_BY_LISTING',
          data: {
            ...notificationListing,
            applications: [],
            orgId: notification.about.id,
            status: notification.data.listingApplication.status,
            count: 0,
            newCount: notification.data.listingApplication.newCount
          }
        };
        listing.data.count += 1;
        listing.created =
          acc[notificationListing.id] &&
          new Date(acc[notificationListing.id].created) >
            new Date(notification.created)
            ? acc[notificationListing.id].created
            : notification.created;
        listing.data.applications.push({
          id: notification.data.listingApplication.id,
          notificationId: notification.id
        });
        return {
          ...acc,
          [listing.data.id]: listing
        };
      }
      return acc;
    },
    {}
  );

  const notifications = [
    ...otherNotifications,
    ...values(notificationsByListingId)
  ];

  return notifications;
};
